import {useMemo} from 'react';
import {useEventNews} from './useEventNews';

export function useLastNews(eventId, count = 1) {
    const news = useEventNews(eventId);

    return useMemo(() => news.slice(0, count), [news, count]);
}
